/* Forma canónica del formulario de evento.
 *
 * Es la misma para crear y para editar: lo único que cambia entre los dos modos
 * son los valores iniciales y a qué endpoint se manda el resultado. */

export const MODO_CREAR = "create";
export const MODO_EDITAR = "edit";

export const MAX_ARCHIVOS = 10;
// el límite real lo pone el backend (10MB por archivo): ver utils/media.js
export { MAX_TAMANIO_ARCHIVO } from "../../utils/media";

export const TIPO_MAPA_ZONAS = "zonas";

export const fechaVacia = () => ({
  id: null,
  fecha: "",
  hora_inicio: "",
  hora_fin: "",
  acceso_inicio: "",
  // oculta: no se muestra al público ni se venden sus tarifas
  oculta: false,
});

export const eventoVacio = () => ({
  evento: "",
  descripcion: "",
  eventos_tipos_id: "",
  privado: null,
  direccion: "",
  ciudad: "",
  provinciaId: "",
  tipoMapa: TIPO_MAPA_ZONAS,
  fechas: [fechaVacia()],
  /* Un solo array de objetos {url, type, format, public_id} en lugar de los
   * cinco arrays paralelos que había antes: reordenar movía sólo algunos y
   * dejaba los tipos desalineados (un video pasaba a renderizarse como imagen). */
  media: [],
  sponsors: [],
});

export const sponsorVacio = (orden) => ({
  id: `temp_${Date.now()}`,
  nombre: "",
  url: "",
  type: "",
  format: "",
  public_id: "",
  orden,
  isNew: true,
});
